import { api } from "utils";
import { API_ENDPOINTS } from "utils";
import { store } from "store/store";
import { setLoginState } from "store/reducers/app";
import { handleError } from "utils/handleError";
import axios from "axios";
import { API_BASE_URL } from "utils";

const ProfileController = {};

ProfileController.getMe = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.USER_ME, { timeout: 10000 });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

ProfileController.changeName = async (firstName, lastName) => {
  try {
    const body = {
      first_name: firstName,
      last_name: lastName,
    };
    const response = await api.patch(API_ENDPOINTS.CHANGE_NAME, body);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

ProfileController.changePassword = async (oldPassword, newPassword) => {
  try {
    const body = {
      old_password: oldPassword,
      new_password: newPassword,
    };
    const response = await api.patch(API_ENDPOINTS.CHANGE_PASSWORD, body);

    if (response.status === 200) {
      store.dispatch(setLoginState(false));
    }

    return response.data;
  } catch (error) {
    throw new Error(error);
  }
};

ProfileController.changeEmail = async (oldPassword, email) => {
  try {
    const body = {
      old_password: oldPassword,
      email: email,
    };
    const response = await api.patch(API_ENDPOINTS.CHANGE_EMAIL, body);

    if (response.status === 200) {
      store.dispatch(setLoginState(false));
    }

    return response.data;
  } catch (error) {
    handleError(error);
  }
};

ProfileController.changeProfilePicture = async (file) => {
  try {
    let currentLanguage = localStorage.getItem("langId");
    if (currentLanguage === "US") {
      currentLanguage = "EN";
    }

    if (!file) {
      console.error("No file selected.");
      return;
    }

    const formData = new FormData();
    formData.append("profile_picture", file);

    const token = localStorage.getItem("access_token");

    const response = await axios.patch(
      `${API_BASE_URL}${API_ENDPOINTS.CHANGE_PROFILE_PICTURE}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLanguage,
        },
      }
    );

    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export default ProfileController;
